export const navigation = [
  {
    text: 'Home',
    path: '/home',
    icon: 'home',
  },
  {
    text: 'Dashboards',
    path: '/dashboard',
    icon: 'chart',
  },
  // {
  //   text: 'Training Docs',
  //   path: '/training',
  //   icon: 'user'
  // },
  {
    text: 'Applications',
    icon: 'globe',
    items: [
      {
        text: 'Core',
        icon: 'assets/tlogos/main.png',
        link: 'truthEngineAppUrl',
      },
      {
        text: 'Tracking',
        icon: 'assets/tlogos/tracking.png',
        link: 'trackingAppUrl',
      },
      {
        text: 'Costing',
        icon: 'assets/tlogos/costing.png',
        link: 'purchaseOrdersAppUrl',
      },
      {
        text: 'Estimating',
        icon: 'assets/tlogos/estimating.png',
        link: 'estimatingAppUrl',
        visible: false,
      },
      {
        text: 'Config',
        icon: 'assets/tlogos/config.png',
        link: 'configAppUrl',
        visible: false,
      },
      {
        text: 'Admin',
        icon: 'assets/tlogos/admin.png',
        link: 'adminAppUrl',
        visible: false,
      },
    ],
  },
]
